// extracted by mini-css-extract-plugin
export default {"label":"autocomplete_label__xRfwI","inputContainer":"autocomplete_inputContainer__t51uY","loadingContainer":"autocomplete_loadingContainer__dX+SJ"};